import { CSSProperties } from 'react'

export const s = {
  spaceName: { fontWeight: 500, fontSize: '24px', color: '#262626', marginBottom: '4px' },
  lightText: { fontWeight: 500, fontSize: '14px', color: '#595959' },
  midText: { fontWeight: 500, fontSize: '14px', color: '#262626' },
  labelText: { fontWeight: 600, fontSize: '16px', color: '#262626' },
  msgText: { color: '#262626', width: '100%', marginBottom: 16 },
  tag: {
    padding: '4px 8px',
    marginRight: 8,
    marginTop: 8,
    color: '#262626',
    fontSize: '14px',
  },
  detail: {
    fontWeight: 600,
    fontSize: '16px',
    color: '#383838',
    lineHeight: '24px',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  } as CSSProperties,
  tour: {
    minWidth: '132px',
    marginTop: '-18px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  } as CSSProperties,
}
